import Index from '../../views/menu/Index';
import Categories from '../../views/menu/Categories';
import Products from '../../views/menu/Products';
import Advices from '../../views/menu/Advices';
import Product from '../../views/menu/Product';

export default [
    {
        path: '/menu',
        component: Index,
        children: [
            {
                path: '',
                name: 'menu.categories',
                component: Categories,
                meta: {requiresOrderOptions: true, showNav: true, showOptionbar: true, headerTitleKey: 'menu'}
            },
            {
                path: 'lista/:id',
                name: 'menu.category.products',
                component: Products,
                meta: {requiresOrderOptions: true, showNav: true, showOptionbar: true, headerTitleKey: 'menu'}
            },
            {
                path: 'consigli',
                name: 'menu.category.advices',
                component: Advices,
                meta: {requiresOrderOptions: true, showNav: true, showOptionbar: true, headerTitleKey: 'consigliperte'}
            },
            {
                path: ':category_id/scheda/:id',
                name: 'menu.category.product',
                component: Product,
                meta: {requiresOrderOptions: true, showNav: true, showOptionbar: true, headerTitleKey: 'menu'}
            }
        ]
    }
]
